module.exports = __webpack_public_path__ + "img/zoom-out.c19f86a2.svg";